<template>
  <figure v-lazyload class="image__wrapper overflow-hidden mb-0">
    <Spinner class="image__spinner" />
    <img
      class="image__item object-cover object-top"
      :data-avatar="avatar"
      :data-url="source"
      :alt="alt || 'Image'"
    />
  </figure>
</template>

<script>
import Spinner from './Spinner.vue'

export default {
  name: 'ImageBox',
  components: {
    Spinner
  },
  props: {
    source: {
      type: String,
      required: true
    },
    avatar: Boolean,
    alt: String
  }
}
</script>
<style scoped lang="scss">
.image {
  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    // border-radius: 4px;

    &.loaded {
      .image {
        &__item {
          visibility: visible;
          opacity: 1;
          border: 0;
        }

        &__spinner {
          display: none;
          width: 100%;
        }
      }
    }
  }

  &__item {
    height: 100%;
    width: 100%;
    border-radius: 4px;
    transition: all 0.4s ease-in-out;
    opacity: 0;
    visibility: hidden;
  }
}
</style>
